  import React, { useState, useEffect } from 'react';
  import axios from 'axios';  // Axios를 불러옴
  import styles from './Signup.module.css'; // CSS Module import


  import HeaderSection from '../all_pages/HeaderSection';  // HeaderSection 컴포넌트 불러오기

  import Group_of_characters from '../../assets/Group_of_characters.svg'; // 로고 이미지 import

  import { useNavigate } from 'react-router-dom';



  const apiUrl = process.env.REACT_APP_API_URL;  // 환경 변수로 API URL 불러오기
  

  const Signup = () => {

    const [step, setStep] = useState(1);  // 현재 페이지 상태
    const [loginId, setLoginId] = useState('');  // 로그인 ID 추가
    const [username, setUsername] = useState('');  // 사용자 닉네임 추가
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');


    const nextStep = () => setStep(step + 1);
    const prevStep = () => setStep(step - 1);
    const navigate = useNavigate(); // navigate 정의


    // 되나??

    // 아이디 검증


    // const [isUsernameValid, setIsUsernameValid] = useState(false); // 아이디 유효성 여부

    const [isLoginidValid, setIsLoginidValid] = useState(false);

    // const [isLoginididAvailable, setIsLoginidAvailable] = useState(false); // 아이디 중복 여부
    const [isLoginidAvailable, setIsLoginidAvailable] = useState(false); // 아이디 중복 여부

    const [loginIdFeedbackMessage, setLoginIdFeedbackMessage] = useState(''); // 아이디 중복 확인 피드백 메시지
    const [loginIdLoading, setLoginIdLoading] = useState(false); // 아이디 중복 확인 로딩 상태

    /// 아이디 검증 끝


    //비밀번호 검증 변수 선언

    const [isPasswordAvailable, setIsPasswordAvailable] = useState(false); // 비밀번호 유효성 여부
    const [PWfeedbackMessage, setPWFeedbackMessage] = useState(''); // 피드백 메시지
    /// 비밀번호 검증 변수 선언 끝.

    /////////////// 이메일 변수 선언
    const [isEmailAvailable, setISEmailAvailabe] = useState(false);
    const [EmailfeedbackMessage, setEmailfeedbackMessage] = useState(''); 
    ////////// 이메일 변수 선언 끝.


    ///////////////////// 닉네임 변수 선언 
    const [isUsernameAvailable, setISUsernemeAvailabe] = useState(false);
    const [UsernemefeedbackMessage, setUsernemefeedbackMessage] = useState('');
    const [loading, setLoading] = useState(false); // 로딩 상태

    ///////////////////// 닉네임 변수 선언 끝.
    ////////////////////////////////////////////////////////////////////////////////////


  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // 서비스 이용 약관 동의 시작

    // 체크박스 상태 관리
    const [allChecked, setAllChecked] = useState(false);
    const [termsChecked, setTermsChecked] = useState(false);
    const [privacyChecked, setPrivacyChecked] = useState(false);

    // 두 개의 체크박스가 모두 체크되면 "모두 동의" 자동 체크
    useEffect(() => {
      if (termsChecked && privacyChecked) {
        setAllChecked(true);
      } else {
        setAllChecked(false);
      }
    }, [termsChecked, privacyChecked]);


  // 서비스 이용 약관 동의 끝.
  /////////////////////////////////////////////////////////////////////////////////////////////////////////

  //////////////////////////////// 이용약관 검증 함수 시작

  const handleAllChecked = () => {
    const newAllChecked = !allChecked;
    setAllChecked(newAllChecked);
    setTermsChecked(newAllChecked);
    setPrivacyChecked(newAllChecked);
  };

  const handleTermsChecked = () => {
    setTermsChecked(!termsChecked);
  };

  const handlePrivacyChecked = () => {
    setPrivacyChecked(!privacyChecked);
  };

  ////////////////////////////////
  //////////////////////////////////////////////////////////////// 이용약관 검증 함수 끝.



  ////////////////////////////////////////////////
  ////////////////// 아이디 검증 함수 시작

    // 아이디가 변경될 때마다 유효성 검사
    useEffect(() => {
      if (loginId) {
        const isValid = validateLoginID(loginId);
        setIsLoginidValid(isValid);
        setIsLoginidAvailable(false); // 새로운 값 입력 시 중복 확인 버튼 활성화
        setLoginIdFeedbackMessage(isValid ? '중복 확인을 진행해 주세요!' : '사용할 수 없는 아이디예요!');
      } else {
        setLoginIdFeedbackMessage(''); // 아이디가 비어있을 때 메시지 초기화
        setIsLoginidValid(false); // 아이디가 없으면 다음으로 못 가게 설정
      }
    }, [loginId]);

// 아이디 중복 확인 함수 
const checkLoginIdAvailability = async () => {
  if (!validateLoginID(loginId)) {
      setLoginIdFeedbackMessage('아이디 조건을 만족하지 않습니다.');
      setIsLoginidAvailable(false);
      return;
  }

  try {
      setLoginIdLoading(true); // 로딩 상태 설정

      const response = await axios.post(`${apiUrl}/accounts/check-loginid/`, { login_id: loginId });
      if (response.data.available) {
          setIsLoginidAvailable(true);  // 중복 체크 통과 시 true 설정
          setLoginIdFeedbackMessage('사용할 수 있는 아이디입니다.');
      } else if (response.data.error && response.data.error.login_id && response.data.error.login_id.includes('user with this login id already exists.')) {
          setIsLoginidAvailable(false);  // 중복된 아이디일 경우 false 설정
          setLoginIdFeedbackMessage(<span className={styles.errorMessage}>이 아이디는 사용할 수 없습니다.<br></br>다른 아이디로 시도해주세요.</span>);
      } else {
          setIsLoginidAvailable(false);  // 다른 이유로 실패한 경우 false 설정
          setLoginIdFeedbackMessage('아이디 중복 여부를 확인할 수 없습니다.');
      }
  } catch (error) { 
      setIsLoginidAvailable(false); // 에러 발생 시 false 설정
      if (error.response && error.response.status === 400 && error.response.data.error && error.response.data.error.login_id && error.response.data.error.login_id.includes('user with this login id already exists.')) {
          setLoginIdFeedbackMessage(<span className={styles.errorMessage}>이 아이디는 사용할 수 없습니다.<br></br>다른 아이디로 시도해주세요.</span>);
      } else {
          setLoginIdFeedbackMessage(<span className={styles.errorMessage}>서버 요청에 실패했습니다. 다시 시도해주세요.</span>);
      }
      console.error('아이디 중복 체크 오류:', error);
  } finally {
      setLoginIdLoading(false); // 로딩 종료
  }
};
///////////////////// 아이디 검증 함수 끝.



    // 아이디 정책 검사 함수
  // 아이디 정책 검사 함수
    const validateLoginID = (loginId) => {
      const isLengthValid = loginId.length >= 4 && loginId.length <= 16;
      const isLowercaseValid = /^[a-z0-9]+$/.test(loginId); // 소문자와 숫자만 허용 (특수문자 X)
      const isNoSpace = !/\s/.test(loginId); // 공백 허용하지 않음
      const isNoKorean = !/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(loginId); // 한글 허용하지 않음

      return isLengthValid && isLowercaseValid && isNoSpace && isNoKorean;
    };
    
  // 아이디 검증 함수 끝.
  ////////////////////////////////
  ////////////////////////////////////////


  //////////////////////////// 비밀번호 검증 함수 시작

  useEffect(() => {
    if (password) {
      const isValid = validatepassword(password);
      setIsPasswordAvailable(isValid);
      setPWFeedbackMessage(isValid ? '사용할 수 있는 비밀번호예요!' : '사용할 수 없는 비밀번호예요!');
    } else {
      setPWFeedbackMessage(''); // 비밀번호가 비어있을 때 메시지 초기화
      setIsPasswordAvailable(false); // 비밀번호가 없으면 다음으로 못 가게 설정
    }
  }, [password]);


  const validatepassword = (password) => {
    const isLengthValid = password.length >= 8; // 최소 8자 이상
    const isNoSpace = !/\s/.test(password); // 공백 허용하지 않음
    const isNoKorean = !/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(password); // 한글 허용하지 않음
    // const hasSpecialChar = /[!@$%]/.test(password); // 특수문자 포함 (!@$%)
    const hasSpecialChar = /^[a-zA-Z0-9!@$%]+$/.test(password) && /[!@$%]/.test(password); // !@$%만 허용


    return isLengthValid && hasSpecialChar && isNoSpace && isNoKorean;
  };


  // 비밀번호 검증 함수 끝.
  ////////////////////////////
  ////////////////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////


  //////////////////////////////// 이메일 검증 함수 시작

  useEffect(() => {
    if (email) {
      const isValid = validateemail(email);
      setISEmailAvailabe(isValid);
      setEmailfeedbackMessage(isValid ? '사용할 수 있는 이메일이에요!' : '이메일을 정확히 작성해주세요!');
    } else {
      setEmailfeedbackMessage(''); // 비밀번호가 비어있을 때 메시지 초기화
      setISEmailAvailabe(false); // 비밀번호가 없으면 다음으로 못 가게 설정
    }
  }, [email]);


  const validateemail= (email) => {
    const hasAtSymbol = /@/.test(email); // "@"이 포함되어 있는지 확인
    const isNoSpace = !/\s/.test(email); // 공백이 없는지 확인
    const isValidFormat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email); // 일반적인 이메일 형식
    

    return hasAtSymbol && isNoSpace && isValidFormat;
  };

  //////////////////////////////// 이메일 검증 함수 끝.


  ///////////////////// 닉네임 검증 함수 시작

//   useEffect(() => {
//     if (username) {
//         const isValid = validateUsername(username);
//         if (isValid) {
//             checkUsernameAvailability();
//         } else {
//             setISUsernemeAvailabe(false);
//             setUsernemefeedbackMessage('사용할 수 없는 닉네임이에요!');
//         }
//     } else {
//         setUsernemefeedbackMessage(''); // 닉네임이 비어있을 때 메시지 초기화
//         setISUsernemeAvailabe(false); // 닉네임이 없으면 다음으로 못 가게 설정
//     }
// }, [username]);


useEffect(() => {
  if (username) {
    const isValid = validateUsername(username);
    setISUsernemeAvailabe(false); // 새로운 입력값이 들어오면 중복 확인 버튼 활성화
    setUsernemefeedbackMessage(isValid ? '중복 확인을 진행해 주세요!' : '사용할 수 없는 닉네임이에요!');
  } else {
    setUsernemefeedbackMessage(''); // 닉네임이 비어있을 때 메시지 초기화
    setISUsernemeAvailabe(false);
  }
}, [username]);

  const validateUsername = (username) => {
    const isLengthValid = username.length >= 2 && username.length <= 12; // 최소 2자 이상, 최대 12자 이하
    const isNoSpace = !/\s/.test(username); // 공백 허용하지 않음
    const hasValidChars = /^[^!@#$%^&*(),.?":{}|<>]+$/.test(username); // 특수문자 금지

    return isLengthValid && isNoSpace && hasValidChars;
  };

// 닉네임 중복 확인 함수  
const checkUsernameAvailability = async () => {
  if (!validateUsername(username)) {
      setUsernemefeedbackMessage('닉네임 조건을 만족하지 않습니다.');
      setISUsernemeAvailabe(false);  // 여기에서 false 설정
      return;
  }

  try {
      setLoading(true); // 로딩 시작
      const response = await axios.post(`${apiUrl}/accounts/check-username/`, { username }, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      if (response.data.available) {
          setISUsernemeAvailabe(true);  // 중복 체크 통과 시 true 설정
          setUsernemefeedbackMessage('사용할 수 있는 닉네임입니다.');
      } else if (response.data.error && response.data.error.username && response.data.error.username.includes('이미 사용 중인 닉네임입니다.')) {
          setISUsernemeAvailabe(false);  // 중복된 닉네임이면 false 설정
          setUsernemefeedbackMessage(<span className={styles.errorMessage}>이 닉네임은 사용할 수 없습니다! 다른 닉네임을 사용해 주세요!</span>);
      } else {
          setISUsernemeAvailabe(false);  // 다른 이유로 실패한 경우 false 설정
          setUsernemefeedbackMessage('닉네임 중복 여부를 확인할 수 없습니다.');
      }
  } catch (error) {
      setISUsernemeAvailabe(false); // 에러 발생 시에도 false로 설정
      if (error.response && error.response.status === 400 && error.response.data.error && error.response.data.error.username && error.response.data.error.username.includes('이미 사용 중인 닉네임입니다.')) {
          setUsernemefeedbackMessage(<span className={styles.errorMessage}>이 닉네임은 사용할 수 없습니다! 다른 닉네임을 사용해 주세요!</span>);
      } else {
          setUsernemefeedbackMessage(<span className={styles.errorMessage}>서버 요청에 실패했습니다. 다시 시도해주세요.</span>);
      }
      console.error('닉네임 중복 체크 오류:', error);
  } finally {
      setLoading(false); // 로딩 종료
  }
};
///////////////////// 닉네임 검증 함수 끝.


  

  ///////////////////// 회원가입 데이터 서버로 전송 
  const handleSignup = async () => {
    try {
      // 회원가입 API로 데이터 전송
      const response = await axios.post(`${apiUrl}/accounts/signup/`, {
        login_id: loginId,   // 아이디
        username: username,  // 닉네임
        email: email,        // 이메일
        password: password,  // 비밀번호
      });

      if (response.status === 201) {
        console.log("회원가입 성공!");
        // 회원가입이 성공하면 메인 페이지로 이동 (예: 페이지 리다이렉트)
        window.location.href = '/login';
      } else {
        console.log("회원가입 실패:", response.data.error);
      }
    } catch (error) {
      console.error('회원가입 오류:', error);
    }
  };



  ///////////////////// 회원가입 데이터 서버로 전송 끝. 

    return (

      
      <div className={styles.layout}>
        {step === 1 && (
          <div className={styles.agreementContainer}>
          <HeaderSection 
            title="회원가입" 
            onBack={() => navigate('/login')} 
            onCancel={() => navigate('/login')} 
          />

            <h1 className={styles.title}>글로업 서비스 이용 <br />약관 동의</h1>
            <p className={styles.description}>글로업을 이용하시려면 약관에 동의해주세요.</p>

            <div className={styles.checkboxform}>
              <div className={styles.checkboxContainer}>
                <label className={styles.checkboxLabel}>
                  <input
                    className={styles.checkbox} // 스타일 클래스 추가
                    type="checkbox"
                    checked={allChecked}
                    onChange={handleAllChecked}
                  />
                  모두 동의합니다
                </label>
              </div>
              <hr className={styles.hrtag}></hr>

              <div className={styles.checkboxContainer}>
                <label className={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    className={styles.checkbox} // 스타일 클래스 추가
                    checked={termsChecked}
                    onChange={handleTermsChecked}
                  />
                  <strong>(필수)</strong>글로업 서비스 이용 약관
                  <a href="/terms" className={styles.detailLink}>자세히</a>
                </label>
              </div>

              <div className={styles.checkboxContainer}>
                <label>
                  <input
                    type="checkbox"
                    className={styles.checkbox} // 스타일 클래스 추가
                    checked={privacyChecked}
                    onChange={handlePrivacyChecked}
                  />
                  <strong>(필수)</strong>개인정보 수집 및 이용 동의
                  <a href="/privacy" className={styles.detailLink}>자세히</a>
                </label>
              </div>
            </div>
            <div className={styles.nextButtonContainer}> 
              <button
                className={styles.nextButton}
                onClick={nextStep}
                disabled={!termsChecked || !privacyChecked} // 두 체크박스가 모두 체크되어야 활성화
              >
                다음으로
              </button>
            </div>
          </div>
        )}
        {step === 2 && (
          <div className={styles.agreementContainer}>
            <HeaderSection title="회원가입" onBack={prevStep} onCancel={() => navigate('/login')} />


          {/* 중간 내용 */}
          <div className= {styles.middletext} >
            <h1 >아이디를 <br></br>입력해주세요.</h1>
            {/* <h2 className={styles.title}>아이디를 입력해주세요</h2> */}
            <p className={styles.middletextintroductionp}>
              아이디는 4~16자의 소문자, 숫자를 사용할 수 있고<br />
              공백과 특수문자는 사용할 수 없어요!
            </p>

            <div className={styles.signupInputContainer}>
              <label htmlFor="loginId" className={styles.signupLabel}>아이디</label>
              <div className={styles.inputWithButton}>
                <input 
                  type="text" 
                  id="loginId" 
                  value={loginId}
                  onChange={(e) => setLoginId(e.target.value)} 
                  className={styles.signupInput} 
                  placeholder="gloup" 
                />
                

                {/* 아이디 중복 버튼 */}
                <button
                  className={styles.checkButton}
                  onClick={checkLoginIdAvailability} // 닉네임 중복 체크 버튼 클릭 시 실행
                  disabled={loginIdLoading || !validateLoginID(loginId)|| isLoginidAvailable} // 중복 체크 중이거나 닉네임 유효성 체크 실패 시 비활성화
                >
                  중복 확인
                </button>
            </div>
            {loginIdFeedbackMessage && (
                  <p className={isLoginidValid ? styles.successMessage : styles.errorMessage}>
                    {loginIdFeedbackMessage}
                  </p>
                )}
            </div>
          </div>





          {/* 하단 고정 버튼 */}
          <div className={styles.nextButtonContainer}>
            <button 
              className={styles.nextButton} 
              onClick={nextStep}
              disabled={loginIdLoading || !isLoginidAvailable  || loginIdFeedbackMessage !== '사용할 수 있는 아이디입니다.'} // 아이디가 유효할 때만 버튼 활성화
            >
              다음으로
            </button>
          </div>

          
          
          
          
          </div>
        )}

        {step === 3 && (
          // <div>
          //   <h1>사용자 닉네임 입력</h1>
          //   <input
          //     type="text"
          //     value={username}
          //     onChange={(e) => setUsername(e.target.value)}
          //     placeholder="사용자 닉네임을 입력하세요"
          //   />
          //   <button onClick={prevStep}>이전</button>
          //   <button onClick={handleSubmit}>회원가입</button>
          // </div>

          <div className={styles.agreementContainer}>
            <HeaderSection title="회원가입" onBack={prevStep} onCancel={() => navigate('/login')} />
          
          {/* 중간내용 */}
          <div className= {styles.middletext} >
            <h1 >비밀번호를 <br></br>입력해주세요.</h1>
            {/* <h2 className={styles.title}>아이디를 입력해주세요</h2> */}
            <p className={styles.middletextintroductionp} >
            비밀번호는 최소 8자이상으로 대소문자를 구분하고,<br />
            특수문자(!@$%)를 하나 이상 포함해야 돼요! <br />
              공백과 특수문자는 사용할 수 없어요!
            </p>

            <div className={styles.signupInputContainer}>
              <label htmlFor="password" className={styles.signupLabel}>비밀번호</label>
              <div className={styles.signupInputbox}>
                <input 
                  type="text" 
                  id="password" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)} 
                  className={styles.signupInput} 
                  placeholder="비밀번호를 입력해주세요" 
                />
              </div>
              {PWfeedbackMessage && (
                <p className={isPasswordAvailable ? styles.successMessage : styles.errorMessage}>
                  {PWfeedbackMessage}
                </p>
              )}
            </div>
          </div>


          {/* 하단 고정 버튼 */}
          <div className={styles.nextButtonContainer}>
            <button 
              className={styles.nextButton} 
              onClick={nextStep}
              disabled={!isPasswordAvailable} // 아이디가 유효할 때만 버튼 활성화
            >
              다음으로
            </button>
          </div>


          </div>
        )}

        {step === 4 && (
          <div className={styles.agreementContainer}>
            <HeaderSection title="회원가입" onBack={prevStep} onCancel={() => navigate('/login')} />
          
          {/* 중간내용 */}
          <div className= {styles.middletext} >
            <h1 >이메일을<br></br>입력해주세요.</h1>
            <p className={styles.middletextintroductionp}>
            아이디 및 비밀번호를 찾거나 재설정할 때 필요해요!
            </p>

            <div className={styles.signupInputContainer}>
              <label htmlFor="email" className={styles.signupLabel}>이메일</label>
              <div className={styles.signupInputbox}>
                <input 
                  type="text" 
                  id="email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)} 
                  className={styles.signupInput} 
                  placeholder="이메일을 입력해주세요" 
                />
              </div>
              {EmailfeedbackMessage && (
                <p className={isEmailAvailable ? styles.successMessage : styles.errorMessage}>
                  {EmailfeedbackMessage}
                </p>
              )}
            </div>
          </div>


          {/* 하단 고정 버튼 */}
          <div className={styles.nextButtonContainer}>
            <button 
              className={styles.nextButton} 
              onClick={nextStep}
              disabled={!isEmailAvailable} // 아이디가 유효할 때만 버튼 활성화
            >
              다음으로
            </button>
          </div>



          </div>


        )}

{step === 5 && (
  <div className={styles.agreementContainer}>
    <HeaderSection title="회원가입" onBack={prevStep} onCancel={() => navigate('/login')} />

    {/* 중간내용 */}
    <div className={styles.middletext}>
      <h1>닉네임을 <br />입력해주세요.</h1>
      <p className={styles.middletextintroductionp}>
        당신의 글로 이름을 알려주세요! <br />
        글로의 이름은 2~12자의 숫자와 대소문자를 사용할 수 있어요!
      </p>

      <div className={styles.signupInputContainer}>
        <label htmlFor="username" className={styles.signupLabel}>닉네임</label>
        <div className={styles.inputWithButton}>
        <input 
          type="text" 
          id="username" 
          value={username}
          onChange={(e) => setUsername(e.target.value)} 
          className={styles.signupInput} 
          placeholder="GLO" 
        />


        {/* 닉네임 중복 체크 버튼 */}
        <button
          className={styles.checkButton}
          onClick={checkUsernameAvailability} // 닉네임 중복 체크 버튼 클릭 시 실행
          disabled={loading || !validateUsername(username) || isUsernameAvailable} // 중복 체크 중이거나 닉네임 유효성 체크 실패 시 비활성화
        >
          중복 확인
        </button>

        </div>
        
        {loading ? (
          <p>확인 중...</p>
        ) : (
          <p className={isUsernameAvailable ? styles.successMessage : styles.errorMessage}>
            {UsernemefeedbackMessage}
          </p>
        )}

      </div>
    </div>



    {/* 하단 고정 버튼 */}
    <div className={styles.nextButtonContainer}>
      <button 
        className={styles.nextButton} 
        onClick={nextStep}
        disabled={loading || !isUsernameAvailable || UsernemefeedbackMessage !== '사용할 수 있는 닉네임입니다.'} 
        // 중복 닉네임 체크 통과 후에만 활성화
      >
        다음으로
      </button>
    </div>
    </div>
  )}

  {step === 6 && (
  <div className={styles.agreementContainerplus}>
  {/* <HeaderSection onBack={prevStep} onCancel={() => console.log('취소 버튼 클릭됨')} /> */}
    {/* 중간내용 */}
    <img src={Group_of_characters} alt="캐릭터 떼 샷" className={styles.Group_of_characters} />
    <div className={styles.endingment}>
      <h1>
        가입을 축하해요!
      </h1>
      <p>글로업에서 당신의 글로를 성장 시켜보세요!</p>
    </div>

    {/* 하단 고정 버튼 */}
    <div className={styles.nextButtonContainer}>
      <button 
        className={styles.nextButton} 
        onClick={handleSignup}
        // disabled={loading || !isUsernameAvailable || UsernemefeedbackMessage !== '사용할 수 있는 닉네임입니다.'} 
        // 중복 닉네임 체크 통과 후에만 활성화
      >
        메인으로
      </button>
    </div>


  </div>
  )}



      </div>
    );
  };

  export default Signup;
